<template>
	<div class="login">
		<!-- 顶部Logo -->
		<div class="top">
			<div class="arr">
				<van-icon name="arrow-left" color="#fff" size="1.2rem" style=""  @click="shouye" />
			</div>
			<img @click="goHome()" src="../../assets/login.png" alt="">
		</div>
		<!--登录版块 -->
		<div class="container">
			<div class="action">
				<div class="from">
					<h3>欢迎来到俱百家</h3>
					<div class="plain" v-if="flag==1">
						<van-cell-group>
							<van-field v-model="usertel" left-icon="phone-o" clearable placeholder="请输入手机号" />
							<van-field v-model="password" left-icon="bag-o" clearable type="password" placeholder="6-12位字母数字密码" />
						</van-cell-group>
						<div class="btn">
							<button @click="plainBtn">登录</button>
						</div>
					</div>
					<div class="tel" v-else="flag==1">
						<van-cell-group>
							<van-field v-model="usertel" clearable left-icon="phone-o" placeholder="请输入手机号" />
							<van-field v-model="sms" clearable left-icon="bag-o" placeholder="手机验证码">
								<van-button slot="button" size="small" type="primary" :disabled="code" @click="getcode">{{buttonMsg}}
								</van-button>
							</van-field>
						</van-cell-group>
						<div class="btn">
							<button @click="telBtn">登录</button>
						</div>
					</div>
					<div class="link-a">
						<router-link to="logon"><span>没有账号？</span><span class="active">点击注册</span></router-link>
						<router-link to="password"><span>忘记密码？</span></router-link>
					</div>
				</div>
				<!-- 第三方登录 -->
				<van-divider :style="{borderColor: '#bfbfbf'}">其他登录方式</van-divider>

				<div class="hezikia">
					<div alt="" v-if="flag==1"><img src="../../assets/wx.png" @click="getWx" class="tupian"></div>
					<div class="other" @click="flag=2" :class="{active:flag==2}">
						<div alt="" v-if="flag==1"><img src="../../assets/tupian/验证码登录@2x.png"></div>
					</div>
				</div>
				<div class="hezikia">
					<div alt="" v-if="flag==2"><img src="../../assets/wx.png" @click="getWx" class="tupian"></div>
					<div class="other" @click="flag=1" :class="{active:flag==1}">
						<div alt="" v-if="flag==2"><img src="../../assets/tupian/账号登录@2x.png"></div>
					</div>
				</div>
				<div class="hezikia" v-if="flag==2">
					<span class="yansele">微信登录</span>
					<span class="yansele" v-if="flag==1">验证码登录</span>
					<span class="yansele" v-if="flag==2">账号登录</span>
				</div>
				<div class="erhaoheji" v-if="flag==1">
					<span class="yanselee">微信登录</span>
					<span class="yanselee" v-if="flag==1">验证码登录</span>
					<span class="yangzheng" v-if="flag==2">账号登录</span>
				</div>
				<div v-if="this.result">123{{this.result}}</div>
				<div class="agreement">
					登录就表示您同意俱百家<router-link to="_treaty?id=2">《隐私政策》</router-link>和<router-link to="_treaty?id=1">《服务协议》
					</router-link>
				</div>
				<div class="dibuzi">
					<span>Copyright © 2019-2021 jbj-china.com.cn 版权所有 <br>
						<router-link to="profile?id=3">关于俱百家</router-link> &nbsp;粤ICP备19077977号
					</span>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		props: ['url'],
		data() {
			return {
				usertel: '',
				password: '',
				usertel: '',
				sms: '',
				checked: false,
				flag: 1,
				buttonMsg: '获取验证码',
				code: false,
				iphon: '',
				codes: '',
				wxdata: '',
				user_id: ''
			}
		},
		mounted() {
			//methodName为自定义方法名  （这句代码是关键）
			window.wxlogin = this.wxlogin;
		},
		created() {
			window.wxlogin = this.wxlogin;
			if (this.$route.query.user_id != undefined) {
				this.user_id = this.$route.query.user_id
				localStorage.setItem('user_id', this.$route.query.user_id);
			}
		},
		methods: {
			//普通方式登录
			randomString(len) {
				len = len || 32;
				var $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'; /****默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
				var maxPos = $chars.length;
				var pwd = '';
				for (let i = 0; i < len; i++) {
					pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
				}
				return pwd;
			},
			plainBtn() {
				if (this.usertel == '') {
					this.$toast('手机号不能为空');
					return false
				}
				if (this.password == '') {
					this.$toast('密码不能为空');
					return false
				}
				if (this.usertel && (!(/^[1][345789]\d{9}$/).test(this.usertel) || !(/^[1-9]\d*$/).test(this.usertel) ||
						this.usertel.length !== 11)) {
					this.$toast('手机号码不符合规范');
					return false;
				}
				if (this.password.length < 6 || this.password.length > 12) {
					this.$toast('密码格式错误');
				} else {
					this.$axios.post(baseUrl + '/mobile/User/login', {
						tel: this.usertel,
						password: this.password
					}).then((res) => {
						if (res.data.code == 1000) {
							this.$toast(res.data.msg);
							localStorage.setItem('Authorization', res.data.data);
							if (this.$route.query.user_id != undefined) {
								this.$router.push({
									path: '/Home'
								})
							} else {
								this.$router.go(-1);
							}
						} else {
							this.$toast(res.data.msg);
						}
					}).catch((err) => {
						console.log(err);
					});
				}
			},
			//手机号验证码登录
			telBtn() {
				if (this.usertel == '') {
					this.$toast('手机号不能为空');
					return false
				}
				if (this.usertel && (!(/^[1][345789]\d{9}$/).test(this.usertel) || !(/^[1-9]\d*$/).test(this.usertel) ||
						this.usertel.length !== 11)) {
					this.$toast('手机号码不符合规范');
					return false;
				}
				if (this.usertel != this.iphon || this.sms != this.codes) {
					this.$toast('验证码错误');
					return false;
				}
				this.$axios.post(baseUrl + '/mobile/User/doLogin', {
					tel: this.usertel
				}).then((res) => {
					if (res.data.code == 1000) {
						this.$toast(res.data.msg);
						localStorage.setItem('Authorization', res.data.data);
						if (this.$route.query.user_id != undefined) {
							this.$router.push({
								path: '/Home'
							})
						} else {
							this.$router.go(-1);
						}
					}
					this.$toast(res.data.msg);
				}).catch((err) => {
					console.log(err);
				});
			},
			back() {
				this.$router.go(-1);
			},
			//获取验证码
			getcode() {
				if (this.usertel === '') {
					this.$toast('请填写手机号');
					return false;
				} else if (this.usertel && (!(/^[1][345789]\d{9}$/).test(this.usertel) || !(/^[1-9]\d*$/).test(this.usertel) ||
						this.usertel.length !== 11)) {
					this.$toast('手机号码不符合规范');
					return false;
				} else {
					this.code = false
				}
				this.$axios.post(baseUrl + '/mobile/User/get_login_code', {
					tel: this.usertel
				}).then((res) => {
					if (res.data.code == 2001) {
						this.$toast(res.data.msg);
						this.iphon = res.data.data.tel;
						this.codes = res.data.data.code;
						this.buttonMsg = 60;
						this.code = true
						var auth_timer = setInterval(() => {
							this.buttonMsg--;
							if (this.buttonMsg <= 0) {
								this.buttonMsg = '获取验证码'
								this.code = false
								clearInterval(auth_timer)
							}
						}, 1000)
					} else {
						this.$toast(res.data.msg);
					}
				}).catch((err) => {
					console.log(err);
				});
			},
			shouye() {
				if (this.user_id == '') {
					this.$router.go(-1);
				} else {
					this.$router.push({
						path: '/Home'
					})
				}
			},
			getWx() {
				this.$toast.loading({
					message: '加载中...',
					forbidClick: true,
					duration: 4000
				});
				BSL.Login('WEIXIN', '', 'wxlogin')
			},
			wxlogin(result) {
				localStorage.setItem('wxinformation', result)
				this.wxdata = JSON.parse(result)
				this.$axios.post(baseUrl + '/mobile/User/checkBind', {
					unionid: this.wxdata.unionid
				}).then(res => {
					if (res.data.code == 1000) {
						localStorage.setItem('Authorization', res.data.data);
						this.$toast("登录成功");
						setTimeout(() => {
							window.location.href = '/Home';
						}, 1000)
					} else {
						this.$router.push({
							path: '/wxphone'
						})
					}
				})
			},
			//暂无功能
			goHome() {
				this.$router.push({
					path: '/Home'
				})
			},
		}
	}
</script>

<style scoped>
	@import "login.css";

	.dian {
		background: red;
	}

	.from h3 {
		text-align: center;
	}

	.yansele {
		/* margin-left: 0.7rem; */
		color: #c8c8c8;
		font-size: 0.8rem;

	}

	.van-popup--bottom {
		bottom: 0;
		left: 0;
		width: 100%;
	}

	.login>>>.van-button--small {
		line-height: 0.2rem !important;
	}

	.tupian {
		height: 3rem;
		width: 3rem;
	}

	.hezikia {
		width: 70%;
		margin: auto;
		display: -webkit-box;
		display: -ms-flexbox;
		display: flex;
		-ms-flex-pack: distribute;
		justify-content: space-around;
	}

	.dibuzi span {
		font-size: 0.7rem;
		color: #c8c8c8;
	}

	.erhaoheji {
		width: 70%;
		margin: auto;
		display: flex;
		justify-content: space-around;
	}

	.yanselee {

		/* margin-left: 0.7rem; */
		color: #c8c8c8;
		font-size: 0.8rem;
	}

	.yanselee {
		margin-left: 0.7rem;
	}
</style>



// WEBPACK FOOTER //
// src/components/login/login.vue